module.exports = __webpack_public_path__ + "img/money_icon.7fe6ef80.svg";